import React from 'react'

export type ModalComponent = JSX.Element

export interface EnvironmentProps {
  isOpenFin: boolean
  isAdmin: boolean
  isTearout: boolean
}

export const EnvironmentContext = React.createContext<EnvironmentProps>({
  isOpenFin: false,
  isAdmin: false,
  isTearout: false
})
